var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6769,
    cy: 12.882,
    r: 8.82343,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2471 3.63867C15.6411 3.31647 16.1966 3.31666 16.5908 3.63867L16.6729 3.71191L16.6953 3.73535L20.791 8.22559H20.79C20.9607 8.40852 21.0101 8.6223 21.0273 8.72559C21.0478 8.84803 21.0459 8.96108 21.0459 8.99805C21.0459 9.12951 21.0414 9.50675 20.7041 9.85547L20.7051 9.85645L16.6084 14.2646C16.6026 14.2709 16.5968 14.2772 16.5908 14.2832C16.4737 14.3998 16.3371 14.461 16.2529 14.4922C16.1534 14.529 16.0422 14.5551 15.9277 14.5654C15.7237 14.5839 15.3636 14.5628 15.083 14.2832C15.0327 14.233 14.9909 14.1748 14.959 14.1113C14.898 13.9897 14.8544 13.8722 14.8301 13.751C14.8057 13.6295 14.8066 13.5303 14.8066 13.4883V11.7441C12.6526 12.0288 10.769 13.6672 10.3828 15.6553C10.3362 15.8952 10.1614 16.0904 9.92773 16.1621C9.69411 16.2338 9.43979 16.1704 9.2666 15.998C8.95405 15.6866 8.70863 15.1835 8.54395 14.7021C8.37289 14.2021 8.25199 13.6186 8.25195 13.0801C8.25195 9.53926 11.3865 6.6626 14.8066 6.32812V4.58887C14.8066 4.53034 14.8006 4.35623 14.8613 4.1748C14.9278 3.97624 15.0475 3.82903 15.165 3.71191L15.2471 3.63867Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 1.32351,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2661,
    cy: 5.82375,
    r: 0.882343,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.02933,
    cy: 4.05863,
    r: 1.76469,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8235,
    cy: 16.8528,
    r: 1.32351,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.825,
    cy: 12.4412,
    r: 0.441171,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 2.73512,
    r: 0.441171,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6187,
    cy: 3.17629,
    r: 0.882343,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.8bb94db7db3d9f2d3c9cca925b83ac5c.svg";
export { ForwardRef as ReactComponent };